// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"cdfbcc3c448eb675","8194":"f7271e6fc5c397e0"}[chunkId] + ".css";
};